import { appStore } from '@/stores/app';
import { getSearchKeyword, removeSearchKeyword } from '@/stores/search_keyword';

import type { VideoPageSiteData } from './types';

export function appendAffiliateTrackingParams(): void {
    const pageData = appStore.getPageData<VideoPageSiteData>();
    if (!pageData?.affiliateTracking) return;

    const videoId = String(pageData.videoId);
    const keyword = getSearchKeyword(videoId);

    const selectors = [
        'a[data-ga-event="aff_join_now_click"]',
        'a[data-ga-event="on_video_text_link"]',
        'a[data-testid="call-to-action"]',
    ];

    const links = document.querySelectorAll<HTMLAnchorElement>(selectors.join(','));

    links.forEach((link) => {
        try {
            const url = new URL(link.href);
            url.searchParams.set('custom_tracking[video_id]', videoId);
            if (keyword) {
                url.searchParams.set('custom_tracking[keyword]', keyword);
            }
            link.href = url.toString();
        } catch {
            // Skip links with invalid URLs
        }
    });

    removeSearchKeyword(videoId);
}
